import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

const AdminRoute = () => {
    const { isAdmin } = useAuth();
    return isAdmin ? <Outlet /> : <Navigate replace to="/app" />;
};

export { AdminRoute };
